import { Brands } from "@/brand/brandConfig";

export const DEFAULT_TERMS_AND_CONDITIONS_KEY = Brands.GameRushMFilter;

export const termsAndConditionsMap = new Map();

termsAndConditionsMap.set(Brands.GameRushMFilter, {
    title: 'Game Rush on Safaricom',
    subtitle: 'Terms and Conditions',
    importantNotice: [
        'These Terms and Conditions contain assumptions of risk and/or liability by Customers and limit and exclude liabilities, obligations, and legal responsibilities which Safaricom will have towards Customers and other persons.',
        'These Terms and Conditions also limit and exclude Customers\' rights and remedies against Safaricom and place various risks, liabilities, obligations, and legal responsibilities on the Customer.',
        'These Terms and Conditions may result in Customers being responsible for paying additional costs and amounts. Safaricom may also have claims and other rights against the Customer.',
        'Customers must read these Terms and Conditions carefully. Use of this product/service constitutes agreement to comply.',
        'These Terms and Conditions must be read together with the standard Safaricom Internet Content Pass Terms and Conditions.'
    ],
    sections: [
        {
            title: '1. Introduction',
            html: `
                <p>1.1 Safaricom customers who subscribe to the Rush Games (RG) service gain access to a mobile gaming service that provides them with access to a catalogue of localized, hyper-casual games.</p>
                <p>The service features a modern, intuitive interface with personalized illustrations and straightforward navigation. Users can log in with their mobile number, create a gaming profile, and participate in regularly refreshed game tournaments.</p>
                <p>Game performance is ranked on leaderboards, and users can track their historical scores, placements, and overall activity within their profile.</p>
                <p>1.2 The Rush Games service is a subscription-based service charged at:</p>
                <ul>
                    <li>The subscription fee is up to KSH 15.00 per day and may be billed in multiple increments until the total daily charge of KSH 15.00 has been fully applied.</li>
                    <li>Users must subscribe at: <a href="https://rgs-gr-wr-goodgamingco-com.migration.penrosesystems.com/" target="_blank" rel="noopener noreferrer">https://rgs-gr-wr-goodgamingco-com.migration.penrosesystems.com/</a></li>
                    <li>Pricing may vary depending on promotional activity or adjustments by Safaricom.</li>
                </ul>
            `
        },
        {
            title: '2. Duration',
            html: `
                <p>2.1 This offering is available from 1 April 2026 until such time as Safaricom elects to terminate it in its sole discretion.</p>
                <p>2.2 Safaricom may amend the duration of the Offer to a shorter or longer period, or withdraw it entirely, with notice to customers.</p>
                <p>2.3 Visit <a href="https://www.safaricom.co.ke/" target="_blank" rel="noopener noreferrer">https://www.safaricom.co.ke/</a> for notices, updates, and/or changes.</p>
            `
        },
        {
            title: '3. Eligibility',
            html: `
                <p>3.1 To participate, the Customer must:</p>
                <ul>
                    <li>Be a Kenyan citizen</li>
                    <li>Reside in Kenya</li>
                    <li>Be a natural person</li>
                    <li>Be 18 years or older or have parental consent</li>
                    <li>Be a Safaricom subscriber</li>
                    <li>Subscribe to the RG service via USSD, mobile site, or other channels made available by Safaricom.</li>
                </ul>
            `
        },
        {
            title: '4. How the Service Works',
            html: `
                <ul>
                    <li>The participant has to play the bi-hourly promoted game that is available on the platform which is part of the Rush Games service.</li>
                    <li>For bi-hourly tournaments a new tournament will be available every 2 hours for the competition period.</li>
                    <li>The Promoter will keep the tournament games secret until the tournament goes live.</li>
                    <li>Tournament games remain undisclosed until they go live.</li>
                    <li>Participants must maintain an active subscription to access the service and submit scores.</li>
                    <li>Scores from completed games determine player standings on the tournament leaderboard.</li>
                    <li>Leaderboard rankings are based solely on accumulated in-game scores.</li>
                    <li>Historical leaderboard placements and gameplay records are available within the user's profile.</li>
                    <li>Users may access and replay previous games available on the platform.</li>
                </ul>
            `
        },
        {
            title: '5. Unsubscribing',
            html: `
                <p>5.1 Customers may unsubscribe at any time by sending <strong>GRSTOP</strong> to <strong>27604</strong>.</p>
                <p>5.2 Upon unsubscribing, the user will lose access to future competitions and features tied to their subscription. Fanclash may retain profile records for regulatory and marketing purposes.</p>
            `
        },
        {
            title: '6. Personal Information',
            html: `
                <p><strong>(a) Definition</strong></p>
                <p>"Personal Information" means personally identifiable information as prescribed in the Data Protection Act, including but not limited to name, address, phone number, identification number, and location data.</p>
                <p><strong>(b) Collection</strong></p>
                <p>We are required by law to collect certain personal information and are legally obligated to deny you the Promotion if such information is not provided.</p>
                <p>We may also collect personal information to ensure quality service delivery. Although voluntary, failure to provide such information may limit service access.</p>
                <p><strong>(c) Privacy</strong></p>
                <p>We are committed to respecting and protecting your privacy. Our privacy statement explains how we collect and use your information, with whom it is shared, and measures taken to protect it. This statement is available via the Safaricom Data Privacy Statement. If unable to access it online, please contact customer care.</p>
                <p><strong>(d) Minors</strong></p>
                <p>A person with parental authority may open and maintain a mobile number in their name on behalf of a minor. Parental authority includes birth parents, legal guardians, or others with demonstrable authority over the minor's affairs.</p>
            `
        },
        {
            title: '7. Limitation of Liability',
            html: `
                <p>7.1 Safaricom is not liable for delayed device or SIM delivery, interruptions to network services, or failures to suspend services upon request.</p>
                <p>7.2 Safaricom will not be liable for loss caused by negligent acts of Safaricom, its employees, or agents, or due to use of devices related to this service.</p>
                <p>7.3 This limitation does not apply where warranties are implied by law to the extent such limitations are disallowed.</p>
            `
        },
        {
            title: '8. General',
            html: `
                <p>8.1 Leaderboards will be updated on the service platform and can be accessed via the RG portal or USSD code (as advised by Safaricom).</p>
                <p>8.2 Safaricom and its directors, employees, agents, and affiliates assume no liability for direct or indirect losses, including physical harm, arising from participation.</p>
                <p>8.3 Safaricom reserves the right to terminate subscriptions in cases of fraud or suspected fraud.</p>
            `
        },
        {
            title: '9. Data Retention',
            html: `
                <p>We retain your data while your profile is active and for up to 6 months post-cancellation for regulatory or promotional purposes.</p>
            `
        },
        {
            title: '10. Your Rights',
            html: `
                <p>You may request cessation of marketing messages at any time by:</p>
                <ul>
                    <li>Writing to us</li>
                    <li>Adjusting preferences via <a href="https://www.safaricom.co.ke" target="_blank" rel="noopener noreferrer">www.safaricom.co.ke</a></li>
                    <li>Following opt-out links on marketing messages</li>
                    <li>Contacting us directly</li>
                </ul>
                <p>We may take up to 21 days to respond.</p>
            `
        },
        {
            title: '11. Contact',
            html: `
                <p>For further information, visit: <a href="https://www.safaricom.co.ke" target="_blank" rel="noopener noreferrer">https://www.safaricom.co.ke</a></p>
            `
        }
    ]
});

termsAndConditionsMap.set(Brands.GameAppWorldMFilter, {
    title: 'GameApp World on Safaricom',
    subtitle: 'Terms and Conditions',
    importantNotice: [
        'These Terms and Conditions contain assumptions of risk and/or liability by Customers and limit and exclude liabilities, obligations, and legal responsibilities which Safaricom will have towards Customers and other persons.',
        'These Terms and Conditions also limit and exclude Customers\' rights and remedies against Safaricom and place various risks, liabilities, obligations, and legal responsibilities on the Customer.',
        'These Terms and Conditions may result in Customers being responsible for paying additional costs and amounts. Safaricom may also have claims and other rights against the Customer.',
        'Customers must read these Terms and Conditions carefully. Use of this product/service constitutes agreement to comply.',
        'These Terms and Conditions must be read together with the standard Safaricom Internet Content Pass Terms and Conditions.'
    ],
    sections: [
        {
            title: '1. Introduction',
            html: `
                <p>1.1 Safaricom customers who subscribe to the GameApp World service gain access to a digital entertainment portal offering downloadable games, essential apps, and browser-based HTML5 games. The service is designed to provide continuous mobile entertainment through a broad catalogue of over 2,500 content items available to eligible subscribers. Subscribers join the service through online banners and landing pages, where they confirm their subscription and receive one day of free trial access. After the trial period, the service continues on a daily subscription basis. Upon successful subscription, users receive an SMS containing the access link and login credentials for the service portal.</p>
                <p>The service is available to Safaricom customers in Kenya with internet-capable mobile devices. Subscribers may cancel the service at any time free of charge, while access to the portal remains subject to applicable data charges and network availability.</p>
                <p>1.2 The Rush Games service is a subscription-based service charged at:</p>
                <ul>
                    <li>The subscription fee is up to KSH 15.00 per day and may be billed in multiple increments until the total daily charge of KSH 15.00 has been fully applied.</li>
                    <li>Users must subscribe at: <a href="https://rgs-gaw-wr-goodgamingco-com.migration.penrosesystems.com/" target="_blank" rel="noopener noreferrer">https://rgs-gaw-wr-goodgamingco-com.migration.penrosesystems.com/</a></li>
                    <li>Pricing may vary depending on promotional activity or adjustments by Safaricom.</li>
                </ul>
            `
        },
        {
            title: '2. Duration',
            html: `
                <p>2.1 This offering is available from 1 April 2026 until such time as Safaricom elects to terminate it in its sole discretion.</p>
                <p>2.2 Safaricom may amend the duration of the Offer to a shorter or longer period, or withdraw it entirely, with notice to customers.</p>
                <p>2.3 Visit <a href="https://www.safaricom.co.ke/" target="_blank" rel="noopener noreferrer">https://www.safaricom.co.ke/</a> for notices, updates, and/or changes.</p>
            `
        },
        {
            title: '3. Eligibility',
            html: `
                <p>3.1 To participate, the Customer must:</p>
                <ul>
                    <li>Be a Kenyan citizen</li>
                    <li>Reside in Kenya</li>
                    <li>Be a natural person</li>
                    <li>Be 18 years or older or have parental consent</li>
                    <li>Be a Safaricom subscriber</li>
                    <li>Subscribe to the RG service via USSD, mobile site, or other channels made available by Safaricom.</li>
                </ul>
            `
        },
        {
            title: '4. How the Service Works',
            html: `
                <ul>
                    <li>The participant has to play the bi-hourly promoted game that is available on the platform which is part of the Rush Games service.</li>
                    <li>For bi-hourly tournaments a new tournament will be available every 2 hours for the competition period.</li>
                    <li>The Promoter will keep the tournament games secret until the tournament goes live.</li>
                    <li>Tournament games remain undisclosed until they go live.</li>
                    <li>Participants must maintain an active subscription to access the service and submit scores.</li>
                    <li>Scores from completed games determine player standings on the tournament leaderboard.</li>
                    <li>Leaderboard rankings are based solely on accumulated in-game scores.</li>
                    <li>Historical leaderboard placements and gameplay records are available within the user's profile.</li>
                    <li>Users may access and replay previous games available on the platform.</li>
                </ul>
            `
        },
        {
            title: '5. Unsubscribing',
            html: `
                <p>5.1 Customers may unsubscribe at any time by sending <strong>GAWSTOP</strong> to <strong>27604</strong>.</p>
                <p>5.2 Upon unsubscribing, the user will lose access to future competitions and features tied to their subscription. Fanclash may retain profile records for regulatory and marketing purposes.</p>
            `
        },
        {
            title: '6. Personal Information',
            html: `
                <p><strong>(a) Definition</strong></p>
                <p>"Personal Information" means personally identifiable information as prescribed in the Data Protection Act, including but not limited to name, address, phone number, identification number, and location data.</p>
                <p><strong>(b) Collection</strong></p>
                <p>We are required by law to collect certain personal information and are legally obligated to deny you the Promotion if such information is not provided.</p>
                <p>We may also collect personal information to ensure quality service delivery. Although voluntary, failure to provide such information may limit service access.</p>
                <p><strong>(c) Privacy</strong></p>
                <p>We are committed to respecting and protecting your privacy. Our privacy statement explains how we collect and use your information, with whom it is shared, and measures taken to protect it. This statement is available via the Safaricom Data Privacy Statement. If unable to access it online, please contact customer care.</p>
                <p><strong>(d) Minors</strong></p>
                <p>A person with parental authority may open and maintain a mobile number in their name on behalf of a minor. Parental authority includes birth parents, legal guardians, or others with demonstrable authority over the minor's affairs.</p>
            `
        },
        {
            title: '7. Limitation of Liability',
            html: `
                <p>7.1 Safaricom is not liable for delayed device or SIM delivery, interruptions to network services, or failures to suspend services upon request.</p>
                <p>7.2 Safaricom will not be liable for loss caused by negligent acts of Safaricom, its employees, or agents, or due to use of devices related to this service.</p>
                <p>7.3 This limitation does not apply where warranties are implied by law to the extent such limitations are disallowed.</p>
            `
        },
        {
            title: '8. General',
            html: `
                <p>8.1 Leaderboards will be updated on the service platform and can be accessed via the RG portal or USSD code (as advised by Safaricom).</p>
                <p>8.2 Safaricom and its directors, employees, agents, and affiliates assume no liability for direct or indirect losses, including physical harm, arising from participation.</p>
                <p>8.3 Safaricom reserves the right to terminate subscriptions in cases of fraud or suspected fraud.</p>
            `
        },
        {
            title: '9. Data Retention',
            html: `
                <p>We retain your data while your profile is active and for up to 6 months post-cancellation for regulatory or promotional purposes.</p>
            `
        },
        {
            title: '10. Your Rights',
            html: `
                <p>You may request cessation of marketing messages at any time by:</p>
                <ul>
                    <li>Writing to us</li>
                    <li>Adjusting preferences via <a href="https://www.safaricom.co.ke" target="_blank" rel="noopener noreferrer">www.safaricom.co.ke</a></li>
                    <li>Following opt-out links on marketing messages</li>
                    <li>Contacting us directly</li>
                </ul>
                <p>We may take up to 21 days to respond.</p>
            `
        },
        {
            title: '11. Contact',
            html: `
                <p>For further information, visit: <a href="https://www.safaricom.co.ke" target="_blank" rel="noopener noreferrer">https://www.safaricom.co.ke</a></p>
            `
        }
    ]
});

export function getTermsAndConditionsContent(termsKey) {
    return termsAndConditionsMap.get(termsKey) || termsAndConditionsMap.get(DEFAULT_TERMS_AND_CONDITIONS_KEY);
}
